export default {
  BASE_URL: '',
  api: [
    {
      name: 'save',
      desc: '新增/编辑项目',
      method: 'POST',
      path: '/crm/self/project/save'
    },
    {
      name: 'audit',
      desc: '项目审核',
      method: 'POST',
      path: '/crm/self/project/audit'
    },
    {
      name: 'del',
      desc: '删除项目',
      method: 'POST',
      path: '/crm/self/project/del'
    },
    {
      name: 'detail',
      desc: '项目明细',
      method: 'GET',
      path: '/crm/self/project/detail'
    },
    {
      name: 'list',
      desc: '项目列表',
      method: 'GET',
      path: '/crm/self/project/list'
    },
    {
      name: 'changeSuInfo',
      desc: '修改项目业务员/批量',
      method: 'POST',
      path: '/crm/self/project/changeSuInfo'
    },
    {
      name: 'getProjectListOfSelf',
      desc: '获取项目列表(下拉框)',
      method: 'GET',
      path: '/crm/self/project/getProjectListOfSelf'
    },
    {
      name: 'add',
      desc: '新增一级项目',
      method: 'POST',
      path: '/crm/self/project/createMain'
    },
    {
      name: 'edit',
      desc: '新增二级项目/编辑一、二级项目',
      method: 'POST',
      path: '/crm/self/project/editChild'
    },
    {
      name: 'modifyEnableStatusV5',
      desc: '启用禁用',
      method: 'GET',
      path: '/crm/self/project/modifyEnableStatus'
    },
    {
      name: 'hasEnableListV5',
      desc: '启用禁用下拉框列表',
      method: 'GET',
      path: '/crm/self/project/hasEnableList'
    },
    {
      name: 'exportProjectV5',
      desc: '导出全量项目列表',
      method: 'POST',
      path: '/crm/self/project/exportExcel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/information/project.js